export default {
	Ink: "Ink",
	Cleaning: "Cleaning",
	Scan: "Scan",
	Paper: "Paper",
}